/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Add_Contact_PromptInputs */



/**
* | output |
* | --- |
* | "Add your contact info and community links." |
*
* @param {Community_Add_Contact_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_add_contact_prompt = /** @type {((inputs?: Community_Add_Contact_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Add_Contact_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez vos informations de contact et liens communautaires.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agrega tu información de contacto y enlaces comunitarios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicione suas informações de contato e links da comunidade.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi le tue informazioni di contatto e i link della comunità.")
	return /** @type {LocalizedString} */ ("Add your contact info and community links.")
});